import React, { Component } from 'react';

class NavButtonMiami extends Component {


  // constructor(props) {
  //   super(props);
  // }

  render() {
    return (
      <div>
        {this.props.mode === "video" ?
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.unit * .5, left: this.props.left, right: this.props.right }}>
            <div>{this.props.children}</div>
          </div>
          :
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.unit * .15, borderBottomRightRadius: this.props.unit * .15 }}>
            <div>{this.props.children}</div>
          </div>
        }
      </div>
    )
  }
}

export default NavButtonMiami




// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/NavButtonMiami.js